let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bPAXi")).then(() => parcelRequire('92BXr'));